import React from 'react';

import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Quote } from '../../../types';
import { RoundedInput } from '../../components/form';
import { PrimaryHeader } from './components/primaryHeader';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    preLine: {
      whiteSpace: 'pre-line',
    },
    topMargin: {
      marginTop: theme.spacing(3),
    },
    terms: {
      opacity: 1,
      fontWeight: 'bold',
    },
  })
);

type Props = {
  quote: Pick<Quote, 'terms_and_conditions' | 'conditions_of_trade'>;
  onChange?: (
    event: React.ChangeEvent<{
      name?: string;
      value: unknown;
    }>
  ) => void;
};

const QuoteTerms: React.ComponentType<any> = (props: Props) => {
  const { quote, onChange } = props;
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState('');

  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : '');
  };

  return (
    <React.Fragment>
      {onChange ? (
        <>
          <PrimaryHeader fieldName="TERMS & CONDITIONS" />
          <RoundedInput
            multiline
            rows={4}
            bottomMargin={false}
            value={quote.terms_and_conditions}
            name="terms_and_conditions"
            onChange={onChange}
          />
        </>
      ) : (
        <>
          <Typography variant="subtitle2" className={`${classes.topMargin} ${classes.terms}`}>
            TERMS & CONDITIONS
          </Typography>
          <Typography variant="subtitle2" className={classes.preLine}>
            {quote.terms_and_conditions}
          </Typography>
        </>
      )}

      {quote.conditions_of_trade && (
        <Accordion
          className={classes.topMargin}
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
          TransitionProps={{ unmountOnExit: true }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Typography variant="h5" gutterBottom>
              Conditions of Trade
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="subtitle2" className={classes.preLine}>
              {quote.conditions_of_trade}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )}
    </React.Fragment>
  );
};

export default QuoteTerms;
